import React from "react";
import { Link } from "react-router-dom";

import { getCsPhoneDisplay, getCsWhatsAppUrl } from "../../lib/contact";
import { storefrontUrl } from "../../lib/storefront";
import { PhoneIcon, SmartphoneIcon } from "./icons";

/** hanamaru AppInstallPrompt/constants.ts PLAY_STORE_URL. */
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=id.kyou.midori";

/**
 * The thin line above the navbar, mirrored from hanamaru
 * `AppInstallPrompt/Strip.tsx`. Desktop only (>=1025px), like the original.
 *
 * Two deliberate differences:
 * - "Help Center (FAQ)" is drawn active here. The visual handover asks for
 *   exactly this one change to the storefront header while the reader is on
 *   /help. It links to this app's home instead of opening a new tab.
 * - The app offer links to the Play Store instead of opening hanamaru's QR
 *   popover; porting the popover would mean porting its QR renderer for one
 *   hover target.
 */
const UtilityStrip = () => (
  <div className="site-strip">
    <a className="site-strip__offer" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
      <SmartphoneIcon className="site-strip__offer-icon" />
      Exclusive Discount &amp; Bonus + Realtime Notification, only in Kyou App
      <span className="site-strip__offer-cta">Get Kyou App now</span>
      <span aria-hidden="true">&rsaquo;</span>
    </a>

    <nav aria-label="Tautan bantuan" className="site-strip__links">
      <Link to="/" className="site-strip__link site-strip__link--active" aria-current="true">
        Help Center (FAQ)
      </Link>
      <a href={storefrontUrl("/terms-and-conditions")} className="site-strip__link">
        Terms and Conditions
      </a>
      <a
        href={getCsWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        title="Chat via WhatsApp"
        className="site-strip__link site-strip__link--phone"
      >
        <PhoneIcon className="site-strip__phone-icon" />
        {getCsPhoneDisplay()}
      </a>
    </nav>
  </div>
);

export default UtilityStrip;
